import AxiosContent from '@/services/api/content/axios_content'

export default {
  uploadFileOneShot: ({parentId, file}, source, onUploadProgress) => {
    let formData = new FormData()
    formData.append("folder_parent_id", parentId)
    formData.append("file", file)
    return AxiosContent.post("/file", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      cancelToken: source.token,
      onUploadProgress
    })
  },

  prepareFileToContent: ({parentId, file, fieldValues = {}}) => {
    let formData = new FormData()
    formData.append("folder_parent_id", parentId)
    formData.append("filename", file.name)
    Object.entries(fieldValues).forEach(([key, value]) => {
      formData.append(`field_values[${key}]`, value)
    })
    return AxiosContent.post("/file/prepare", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
  },

  abortFileUpload: ({nodeId, lockToken}) => {
    return AxiosContent.post('/file/abort', {
      node_id: nodeId,
      lock_token: lockToken
    }, {
      // A completed upload can win the race with cancellation. The abort
      // endpoint reports that as a conflict, which is expected and should not
      // be shown to the user as an application error.
      skipInterceptor: true
    })
  }
}
